import { createTRPCReact } from "@trpc/react-query";

import type { TRPCRouter } from "@bridge/server";
import type { inferRouterInputs, inferRouterOutputs } from "@trpc/server";

export const trpc = createTRPCReact<TRPCRouter>();

export type RouterInput = inferRouterInputs<TRPCRouter>;
export type RouterOutput = inferRouterOutputs<TRPCRouter>;
